import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import { withAreaGetter } from 'providers/AreasConsumers';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import { useEntityExport } from './hooks';

const ExportAction = ({ id, type, getElemByAreaKey }) => {
  const { t } = useTranslation();
  const { exporting, exportEntity } = useEntityExport(id, type);

  return (
    <Portal container={getElemByAreaKey(areas.headerLinks)}>
      <IconButton
        type='download'
        fontSize='medium'
        color='transparent'
        tooltip={t('Transfer.Export')}
        onClick={exportEntity}
        disabled={exporting}
      />
    </Portal>
  );
};

ExportAction.propTypes = {
  id: PropTypes.number,
  type: PropTypes.string,
  getElemByAreaKey: PropTypes.func
};

export default withAreaGetter(ExportAction);
